.prose {
  color: var(--color-text);
  line-height: 1.65;

  /* якорь (#cookies) не прячется под фиксированной шапкой */
  [id] {
    scroll-margin-top: calc(var(--layout-header-height) + var(--space-24));
  }

  h2 {
    margin: clamp(var(--space-28), 3vw, var(--space-40)) 0 var(--space-12);
    font-size: var(--type-legal-heading);
  }
  p,
  li {
    margin-bottom: var(--space-10);
    color: var(--color-text-muted);
  }
  ul {
    padding-left: var(--space-20);
    margin-bottom: var(--space-10);
  }
  a {
    color: var(--color-primary);
  }
  strong {
    color: var(--color-text);
  }
}

.root {
  width: 100%;
  max-width: var(--layout-legal-max);
  margin: 0 auto;
  padding: clamp(var(--space-32), 5vw, var(--space-72)) var(--space-page)
    clamp(var(--space-48), 6vw, var(--space-96));
}

.badge {
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-muted);
  margin-bottom: var(--space-12);
}

.title {
  font-size: var(--type-page);
  text-transform: none;
  letter-spacing: normal;
  margin-bottom: var(--space-12);
}
